import { useQuery } from '@tanstack/react-query';
import { apiGet, SERVICE_PATHS } from '@/lib/api-client';
import type { Message } from '@/types';

/**
 * Fetches all messages. The comms-service returns a flat array.
 */
export function useMessages(serviceId: string) {
  return useQuery<Message[]>({
    queryKey: ['messages', serviceId],
    queryFn: () => apiGet<Message[]>(SERVICE_PATHS.messages),
    staleTime: 10_000,
    enabled: serviceId.length > 0,
  });
}
